import React, { Component, useContext, useEffect, useState } from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, ButtonLast, ButtonFirst } from 'pure-react-carousel';
import Load from './LoadComponent';
import activeLoads from '../../stores/tempLoads'



import 'pure-react-carousel/dist/react-carousel.es.css';
import '../css/App.css';

import loadsStore from '../../stores/loads-store';
import jumpersStore from '../../stores/jumpers-store';
import authStore from '../../stores/auth-store';
import arrow from '../images/arrow-carousel.png';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import { Alert, Badge } from 'reactstrap';
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption
} from 'reactstrap';
import DonutLoader from './DonutLoader';
import Clock from 'react-live-clock'
import StaffCheckin from './modals/staffCheckin';

// const items = [
//     {
//         src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//         altText: 'Slide 1',
//         caption: 'Slide 1'
//     },
//     {
//         src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa20%20text%20%7B%20fill%3A%23444%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa20%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23666%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22247.3203125%22%20y%3D%22218.3%22%3ESecond%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//         altText: 'Slide 2',
//         caption: 'Slide 2'
//     },
//     {
//         src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa21%20text%20%7B%20fill%3A%23333%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa21%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23555%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22277%22%20y%3D%22218.3%22%3EThird%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//         altText: 'Slide 3',
//         caption: 'Slide 3'
//     }
// ];

class LoadPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loads: [],
            completedLoads: [],

            numCompletedSlides: 0,

            numActiveSlides: 1,

            tandemInstructorOptions: [],

            videographerOptions: [],

            affInstructorOptions: [],

            affStudentOptions: [],

            jumperOptions: [],

            coachOptions: [],

            tandemStudentOptions: [],

            totalSlides: 0,

            currentSlide: 0,

            screenwidth: window.innerWidth,

            isloading: false,

            completedLoadNum: '',

            iscompleted: false,

            activeLoad: 0,

            direction: null,

            alert: false,

            alertMessage: '',

            activeIndex: 0,

            loadsToShow: 3,
            columnsPerGroup: 2,
            fontSize: 12,

            usingWaitlist: false,
        };
        this.activeLoadSlide = 0;
        this.scrollTimer1 = loadsStore.scrollTimer1
        // list all events that needs to be listend to
        // list all events that needs to be listend to
        this.loadEvents = [
            { name: loadsStore.getEventPrefix('createLoad'), func: this.handleNewLoad },
            { name: loadsStore.getEventPrefix('updateLoad'), func: this.handleUpdateLoad },
            { name: loadsStore.getEventPrefix('updateLoad2'), func: this.handleUpdateLoad2 },
            { name: loadsStore.getEventPrefix('completeLoad'), func: this.handleCompleteLoad },
            { name: loadsStore.getEventPrefix('getExistingLoads'), func: this.handleExistingLoads },
            { name: loadsStore.getEventPrefix('cancelLoads'), func: this.handleCancelLoads },
            { name: loadsStore.getEventPrefix('resetDay'), func: this.handleResetDay },
            { name: loadsStore.getEventPrefix('clearSession'), func: this.handleSession },
            { name: loadsStore.getEventPrefix('InitilizeLoader'), func: this.InilizeLoader },
            { name: loadsStore.getEventPrefix('makeAlert'), func: this.handleAlert },
            { name: loadsStore.getEventPrefix('updateAllLoads'), func: this.handleUpdateAllLoads },
            { name: loadsStore.getEventPrefix('updateCompletedLoads'), func: this.handleUpdateCompletedLoads },
            { name: loadsStore.getEventPrefix('updateCompletedLoad'), func: this.handleUpdateCompletedLoad },
        ];
        this.jumperEvents = [
            //{ name: jumpersStore.getEventPrefix('staffLoaded'), func: this.handleStaffLoaded },
            { name: jumpersStore.getEventPrefix('clearSession'), func: this.handleSession },
            { name: jumpersStore.getEventPrefix('InitilizeLoader'), func: this.InilizeLoader },

        ];
        // this.authEvents = [
        //     { name: authStore.getEventPrefix('settings'), func: this.onSettingRes },
        // ]
    }

    handleSession = (data) => {

        if (!loadsStore.displayOnly) {
            localStorage.clear();
            this.props.routeHistory.push('/login');
        }
    }

    componentWillMount = () => {
        this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))
        this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));
        // this.authEvents.forEach((evnt) => authStore.on(evnt.name, evnt.func));
        this.onSettingRes()
        window.addEventListener('resize', this.handleWindowSizeChange);
        this.setState({
            isloading: true
        })
    }
    handleStaffLoaded = (staffOptions) => {
        console.log('in handle staff loaded load manager center');
        this.setState({
            staffOptions: staffOptions
        });
    }

    componentDidMount = () => {
        //after state is initialized
        console.log('will update Mount');

        if (localStorage.getItem("displayOnly") !== null) {
            var displayValue = localStorage.getItem("displayOnly");
            var role = localStorage.getItem("role");
            /*
            if (displayValue === "true" && role != 'pilot' && role != 'video edit') {
                this.handleScroll();
            }
            else {
                this.cancelScroll();

              }
              */
        }
        //this.scroll2First();

        this.setState({
            jumploaded: true,
        })
    }


    componentWillUnmount = () => {
        // document.addEventListener('keypress', this.handleKeyDown);
        this.cancelScroll();
        this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));
        this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
        // this.authEvents.forEach((evnt) => authStore.on(evnt.removeListener, evnt.func));
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    scroll2First = () => {

        let { loadsToShow } = this.state;

        var role = localStorage.getItem("role");
        let screenWidth = window.innerWidth;
        let screenNum = 0;
        var totalCompletedSlides;
        var length = this.state.completedLoads.length;
        if (this.state.completedLoads.length > 12 && role !== 'video edit') {
            length = 12;
        }

        totalCompletedSlides = Math.ceil(length / loadsToShow);


        let element = document.getElementsByClassName('carousel-first-btn')
        let element2 = document.getElementsByClassName('carousel-next-btn')

        if (element.length > 0) {
            element[0].click();

            for (var i = 0; i < totalCompletedSlides; i++) {
                element2[0].click();
            }
        }
    }

    onSettingRes = (data) => {
        let { loadsToShow, columnsPerGroup } = this.props.settingObj;
        var numActiveSlides = 1;
        if (this.state.loads.length > 0) {
            numActiveSlides = Math.ceil(this.state.loads.length / loadsToShow);
        }

        var numCompletedSlides = Math.ceil(this.state.completedLoads.length / loadsToShow);
        if (this.state.completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
            numCompletedSlides = Math.ceil(12 / loadsToShow);
        }

        this.setState({
            loadsToShow,
            columnsPerGroup,
            numActiveSlides,
            numCompletedSlides
        });
    }

    handleScroll = () => {
        var scroll = 'right'
        var activeLoadSlide = 0
        var self = this;

        //const carouselContext = useContext(CarouselContext);
        //const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);
        const { completedLoads } = self.state;

        var totalCompletedSlides;
        this.scrollTimer1 = setInterval(function () {
            let screenWidth = window.innerWidth;
            let screenNum = 0;
            var length = self.state.completedLoads.length;
            if (self.state.completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
                length = 12;
            }
            if (screenWidth < 1600) {
                screenNum = 2;
                totalCompletedSlides = Math.ceil(length / 2);
            }
            if (screenWidth >= 1600 && screenWidth <= 2400) {
                screenNum = 3;
                totalCompletedSlides = Math.ceil(length / 3);
            }
            else if (screenWidth > 2400) {
                screenNum = 4;
                totalCompletedSlides = Math.ceil(length / 4);
            }
            if (self.state.loads.length > screenNum) {
                if (scroll == 'right') {
                    let element = document.getElementsByClassName('carousel-next-btn')
                    if (element.length > 0) {

                        ////console.log(this.state.currentSlide);
                        //console.log(self.state);
                        element[0].click();
                        if (element[0].disabled)
                            scroll = 'left'
                    }
                }
                else {
                    let element = document.getElementsByClassName('carousel-first-btn')
                    let element2 = document.getElementsByClassName('carousel-next-btn')

                    if (element.length > 0) {
                        element[0].click();
                        if (activeLoadSlide <= 0 || element[0].disabled)
                            scroll = 'right'

                        //console.log(totalCompletedSlides);
                        for (var i = 0; i < totalCompletedSlides; i++) {
                            element2[0].click();
                        }
                    }
                }
            }
            // else{
            //     clearInterval(self.scrollTimer1);
            // }

        }, 13000)

        //   }
        //   else {
        //       let element = document.getElementsByClassName('carousel-back-btn')
        //       if(element.length>0){
        //         element[0].click();
        //         activeLoadSlide=activeLoadSlide-1
        //         if(activeLoadSlide<=0 || element[0].disabled)
        //           scroll='right'
        //       }

        //   }
        // }, 7000)
    }

    cancelScroll = () => {
        clearInterval(this.scrollTimer1);
    }

    InilizeLoader = (value) => {
        /*
        this.setState({
            isloading: value
        })*/
    }

    onExiting = () => {
        this.animating = true;
    }

    onExited = () => {
        this.animating = false;
    }

    next = () => {
        if (this.animating) return;
        var length = Math.ceil(this.state.loads.length / 2);
        const nextIndex = this.state.activeIndex === length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous = () => {
        if (this.animating) return;
        var length = Math.ceil(this.state.loads.length / 2);
        const nextIndex = this.state.activeIndex === 0 ? length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex = (newIndex) => {
        if (this.animating) return;
        this.setState({ activeIndex: newIndex });
    }


    getCompleteLoads = () => {
        var eventToday = new Date();
        var startDatea = new Date(eventToday.setHours(0, 0, 0, 0))
        var endDatea = new Date(eventToday.setHours(23, 59, 59, 999))
        var that = this;
        Promise.all([loadsStore.getCompletedLoad(startDatea, endDatea)])
            .then(function (result) {
                if (result[0] != false) {
                    that.setState({
                        completedLoads: result[0]
                    })
                    ////console.log("CompleteLoadHistory",result[0])
                }
                else {
                    that.setState({
                        completedLoads: []
                    })
                }
            })
    }

    handleTandemStudentsLoaded = (tandemStudentsOptions) => {
        ////console.log('in handleTandemStudentsLoaded');
        //alert('handle tandem student options' + JSON.stringify(tandemStudentsOptions));

        this.setState({
            tandemStudentOptions: tandemStudentsOptions,
            isloading: false
        });
    }

    handleTandemInstructorsLoaded = (tandemInstructorOptions) => {
        ////console.log('in handleTandemInstructorsLoaded');
        this.setState({
            tandemInstructorOptions: tandemInstructorOptions
        });
    }
    handleAffInstructorsLoaded = (affInstructorOptions) => {
        ////console.log('in handleAffInstructorsLoaded');
        this.setState({
            affInstructorOptions: affInstructorOptions
        });
    }
    handleAffStudentsLoaded = (affStudentOptions) => {
        ////console.log('in handleAffInstructorsLoaded');
        this.setState({
            affStudentOptions: affStudentOptions
        });
    }
    handleVideographersLoaded = (videographerOptions) => {
        ////console.log('in handleVideographersLoaded');
        this.setState({
            videographerOptions: videographerOptions
        });
    }

    handleJumpersLoaded = (jumperOptions) => {
        console.log('in handleJumpersLoaded load manager center');
        this.setState({
            jumperOptions: jumperOptions
        });
    }

    handleCoachesLoaded = (coachOptions) => {
        this.setState({
            coachOptions: coachOptions
        })
    }

    handleNewLoad = (loads) => {
        // console.log('in handleNewLoad');
        //console.log(loads);
        var numActiveSlides = 1;
        if (loads.length > 0) {
            numActiveSlides = Math.ceil(loads.length / this.state.loadsToShow);
        }
        console.log('number active slides');
        console.log(numActiveSlides);
        if ((this.state.loads.length === 0 && loads.length == 1) || numActiveSlides !== this.state.numActiveSlides) {
            //alert('updating slide numbers: numslide: ' + numActiveSlides);
            this.setState({
                loads: loads.filter(load => !load.inAir),
                numActiveSlides
            }, () => {
                this.state.loads.length === 0 ? this.props.isLoading(true) : this.props.isLoading(false)
            },
            );
        }
        this.scroll2First();
    }

    handleUpdateCompletedLoads = (loads) => {
        loadsStore.isLoadCreated = false;
        this.setState({ completedLoads: loads });
        this.handleSlides('new');
    }

    handleUpdateCompletedLoad = (load) => {
        console.log(load);
        //alert('in handle Update Complete Load');
        loadsStore.isLoadCreated = false;
        var newCompletedLoads = this.state.completedLoads.slice();
        let loadIndex = newCompletedLoads.findIndex(l => l._id === load._id);
        newCompletedLoads[loadIndex] = load;
        //alert('in handleUpdateLoad');
        this.setState({ completedLoads: newCompletedLoads });
        this.handleSlides('new');
    }

    handleExistingLoads = (loads) => {
        ////console.log('in handle Existing Loads');
        ////console.log("All Loads",loads)
        //this.setState({ loads: loads });
        //this.handleSlides();
        //this.getCompleteLoads();
        var usingWaitlist = false
        if (loads.activeLoads.length > 0) {
            if (loads.activeLoads[0].isWaitlist) {
                usingWaitlist = true;
            }
        }

        var numActiveSlides = 1;
        if (loads.activeLoads.length > 0) {
            numActiveSlides = Math.ceil(loads.activeLoads.length / this.state.loadsToShow);
        }
        var numCompletedSlides = Math.ceil(loads.completedLoads.length / this.state.loadsToShow);
        if (loads.completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
            var numCompletedSlides = Math.ceil(12 / this.state.loadsToShow);
        }

        this.setState({ completedLoads: loads.completedLoads, usingWaitlist: usingWaitlist, numActiveSlides, numCompletedSlides, isloading: false });
        this.sortLoads(loads.activeLoads);
        //console.log("handleExistingLoads", loads);
        //alert('in handle exisitng loads');
        this.scroll2First();

    }

    handleCancelLoads = (loads) => {
        ////console.log('in handle Existing Loads');
        ////console.log("All Loads",loads)
        //this.setState({ loads: loads });
        //this.handleSlides();
        //this.getCompleteLoads();
        //this.setState({completedLoads: loads.completedLoads}, () => this.sortLoads(loads.activeLoads));
        // if(loads.length % 2 === 0)
        // {
        //     document.getElementsByClassName("carousel-back-btn")[0].click();
        // }
        this.setState({ loads: loads.filter(load => !load.inAir) }, () => {
            this.state.loads.length === 0 ? this.props.isLoading(true) : this.props.isLoading(false)

        });
        //console.log("handleCancelLoads", loads);

    }

    handleUpdateLoad = (load) => {
        // console.log('updated 1111', load)
        var newLoads = this.state.loads.slice();
        let loadIndex = newLoads.findIndex(l => l.loadNum === load.loadNum);
        newLoads[loadIndex] = load;
        //alert('in handleUpdateLoad');
        this.setState({ loads: newLoads.filter(load => !load.inAir) }, () => {
            this.state.loads.length === 0 ? this.props.isLoading(true) : this.props.isLoading(false)

        });
    }

    handleUpdateAllLoads = (loads) => {
        // console.log('handle update all loads');
        //console.log(loads);
        //alert('handle update all loads');

        this.setState({ loads: loads.filter(load => !load.inAir) }, () => {
            this.state.loads.length === 0 ? this.props.isLoading(true) : this.props.isLoading(false)

        });
    }


    handleUpdateLoad2 = (loads) => {
        // console.log("UPDATED 22222")
        this.setState({ loads: loads.filter(load => !load.inAir) }, () => {
            this.state.loads.length === 0 ? this.props.isLoading(true) : this.props.isLoading(false)

        });
    }


    onNextClick = (info) => {
        //console.log(info);
        //alert(info);
    }

    sortLoads(newLoads) {

        /*
        var planeNames = newLoads.map(ld => ld.plane);

        var uniquePlaneNames = [... new Set(planeNames)];

        ////console.log(uniquePlaneNames);

        var loadsByPlane = {};
        var sizes = [];
        uniquePlaneNames.forEach(plane => {

            loadsByPlane[plane] = newLoads.filter(ld => ((ld.groupId === undefined && ld.plane === plane) || (ld.groupId !== undefined && ld.masterPlane === plane))).sort((a, b) => a.loadNum - b.loadNum);

            sizes.push(loadsByPlane[plane].length);
        });

        ////console.log(sizes);

        ////console.log(Math.max(...sizes));

        ////console.log(loadsByPlane);

        var sortedLoads2 = [];

        for (var i = 0; i < Math.max(...sizes); i++) {
            for (var j = 0; j < uniquePlaneNames.length; j++) {
                if (i === 0) {
                    loadsByPlane[uniquePlaneNames[j]][i].isNext = true;
                }

                if (i < loadsByPlane[uniquePlaneNames[j]].length) {
                    if (i > 0 && loadsByPlane[uniquePlaneNames[j]][i].groupId == undefined)
                        loadsByPlane[uniquePlaneNames[j]][i].isNext = false;

                    sortedLoads2.push(loadsByPlane[uniquePlaneNames[j]][i]);
                }
            }
        }
        */
        this.setState({ loads: newLoads.filter(load => !load.inAir) }, () => {
            this.state.loads.length === 0 ?
                this.props.isLoading(true) : this.props.isLoading(false);
            this.scroll2First();
        })
    }


    handleResetDay = (data) => {
        ////console.log('in handle Reset day');
        ////console.log(data.loads);
        this.setState({ loads: data.loads.filter(load => !load.inAir) });
    }

    handleCompleteLoad = (data) => {
        console.log('in handleCompleteLoad load manager center');
        console.log(data);
        //console.log(data.activeLoads);
        ////console.log('in handle complete Load');
        ////console.log(data.load);
        ////console.log("CompletedLoad",data)
        /*
        var newLoads = this.state.loads.slice();
        let loadIndex = newLoads.findIndex(l => l.loadNum === data.load.loadNum);
        if (loadIndex > -1) {
            newLoads.splice(loadIndex, 1);
        }
        */
        // if (data.activeLoads.length % 2 === 0) {
        //     document.getElementsByClassName("carousel-back-btn")[0].click();
        // }
        var newLoads = data.activeLoads.filter(load => !load.inAir);

        var numActiveSlides = 1;
        if (newLoads.length > 0) {
            numActiveSlides = Math.ceil(newLoads.length / this.state.loadsToShow)
        }
        var numCompletedSlides = Math.ceil(data.completedLoads.length / this.state.loadsToShow);
        if (data.completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
            numCompletedSlides = Math.ceil(12 / this.state.loadsToShow)
        }
        ////console.log(newLoads);
        //loads should be sorted coming from backend
        if (newLoads.length===0 ||(numCompletedSlides !== this.state.numCompletedSlides) || (numActiveSlides !== this.state.numActiveSlides)) {
            //alert('in if statement');
            //alert('new completed slide: ' + numCompletedSlides + ": num active slides: " + numActiveSlides);
            this.setState({
                completedLoads: data.completedLoads,
                loads: data.activeLoads.filter(load => !load.inAir),
                isloading: false,
                //iscompleted: true,
                completedLoadNum: data.load.loadNum,
                numCompletedSlides,
                numActiveSlides
            });
            //this.forceUpdate();
            /*
            setTimeout(() => {
                this.setState({
                    iscompleted: false
                })
            }, 4000)*/
            //this.handleSlides();
            this.scroll2First();
        }

    }

    handleAlert = (message) => {
        /*
        this.setState({ alert: true, alertMessage: message });
        setTimeout(() => {
            this.setState({
                alert: false
            })
        }, 4000);
        */
    }

    handleLoadNewJumpers(jumpers) {
        var tandemInstructors = jumpers.filter(jumper => jumper.ratings.rating === 'TANDEM INSTRUCTOR');
        var affInstructors = jumpers.filter(jumper => jumper.ratings.rating === 'AFF INSTRUCTOR');
        var pilots = jumpers.filter(jumper => jumpers.ratings.rating === 'PILOT');
        this.setState({
            jumpers: jumpers,
            affInstructors: affInstructors,
            pilots: pilots,
            tandemInstructors: tandemInstructors
        });
    }

    handleWindowSizeChange = () => {
        loadsStore.loadAllExistingLoads();
        this.setState({ screenwidth: window.innerWidth });
    };

    handleSlides(type = '') {
        // const {loads, completedLoads} = this.state;
        // var screenWidth = window.innerWidth;
        // var totalSlides = 0;
        // var totalLoads = 0;
        // if (screenWidth >= 1366 && screenWidth <= 1600) {
        //     totalSlides = Math.ceil(loads.length / 2);
        // }
        // else if(screenWidth >= 1600 && screenWidth <= 2400)
        // {
        //     totalSlides = Math.ceil(loads.length / 3);
        // }
        // else if(screenWidth >= 2560)
        // {
        //     totalSlides = Math.ceil(loads.length / 4);
        // }

        // if (screenWidth >= 1366 && screenWidth <= 1999) {
        //     totalLoads = Math.ceil(completedLoads.length / 2) + (totalSlides);
        // }
        // else if (screenWidth >= 2000 && screenWidth <= 2599) {
        //     totalLoads = Math.ceil(completedLoads.length / 3) + (totalSlides);
        // }
        // else if(screenWidth >= 2560)
        // {
        //     totalLoads = Math.ceil(completedLoads.length / 4) + (totalSlides);
        // }
        /*
        var activeIndex = 0;
        var isActive = false;
        this.state.loads.forEach((element, index) => {
            if (element.capacity - element.totalJumpers > 0 && !isActive) {
                isActive= true;
                activeIndex= index;
            }
        })

        this.setState(prevState => ({
            //totalSlides: Math.ceil(prevState.loads.length / 2)
            totalSlides: Math.ceil(prevState.loads.length / 2),
            activeLoad: activeIndex
        }));
         */
        //if(type === 'new' && this.state.loads.length > 2) document.getElementsByClassName("carousel-last-btn")[0].click();
    }

    // renderNextLoad = (index,numLoadsPerSlide,loads) => {
    //     var nextLoad = '';
    //     for(let j=0; j<=numLoadsPerSlide,j++;)
    //     {
    //         nextLoad = loads[index * numLoadsPerSlide + j + 1].loadNum;
    //     }

    //     return(<span style={{position:'absolute',top:'-22px',right:'50px',fontSize:'25px'}}>Next Load({nextLoad})</span>)
    // }

    renderSlides = (loads, numSlides, screenWidth, iscompleted, nextLoadNum) => {
        // console.log("🚀 ~ file: LoadManagerCenter.js ~ line 725 ~ loads, numSlides, screenWidth, iscompleted", loads, numSlides, screenWidth, iscompleted)
        if (iscompleted) {
            console.log('rendering completed loads slides');
        }
        else {
            console.log('rendering active load slides');
        }
        let { loadsToShow } = this.state;
        var activeSlides = [];
        let numLoadsPerSlide = 1;

        if (screenWidth >= 1400) {
            numLoadsPerSlide = loadsToShow;
        }
        else if (screenWidth >= 992) {
            numLoadsPerSlide = 3;
        }
        else if (screenWidth >= 500) {
            numLoadsPerSlide = 2;
        }
        console.log("NUMLOADS: PER SLIDE: ", numLoadsPerSlide, this.state.columnsPerGroup);
        // let LoadsClasses = "row show-loads-" + numLoadsPerSlide + " columngroup-" + this.state.columnsPerGroup;
        let LoadsClasses = "row show-loads-" + numLoadsPerSlide + " columngroup-" + this.props.settingObj.columnsPerGroup;

        var numarrays = Array.from(Array(numLoadsPerSlide).keys());
        loads = loads.filter(load => !load.inAir);

        var lastLoadNum = 0;
        if (loads[loads.length - 1]) {
            lastLoadNum = loads[loads.length - 1].loadNum;
        }
        else {

        }

        for (var index = 0; index < numSlides; index += 1) {
            var nextLoad = '';
            var key;
            for (var i = 0; i < numarrays.length; i++) {
                if (loads[index * numLoadsPerSlide + numarrays[i]]) {
                    key = loads[index * numLoadsPerSlide + numarrays[i]].key;
                    break;
                }
            }

            activeSlides.push(
                <Slide index={index} key={key} >
                    <div className={LoadsClasses}
                        style={{ width: '100%', margin: 'auto', position: 'relative' }}
                    >
                        {
                            numarrays.map(num => {
                                var currentLoad = loads[index * numLoadsPerSlide + num + numLoadsPerSlide];
                                if (currentLoad) {
                                    nextLoad = nextLoad != '' ? nextLoad + ',' + currentLoad.loadNum : currentLoad.loadNum;
                                }
                                var loadIndx = index * numLoadsPerSlide + num;
                                if (iscompleted) {
                                    loadIndx = -(loadIndx + 1)
                                }
                                console.log('loadIndx: ' + loadIndx);
                                console.log(loads[index * numLoadsPerSlide + num]);
                                return (
                                    <Load
                                        key={loads[index * numLoadsPerSlide + num] ? loads[index * numLoadsPerSlide + num].key : (index * numLoadsPerSlide + num)}
                                        usingWaitlist={this.state.usingWaitlist}
                                        load={loads[index * numLoadsPerSlide + num] ? loads[index * numLoadsPerSlide + num] : {}}
                                        loads={this.state.loads}
                                        loadNum={loads[index * numLoadsPerSlide + num] ? loads[index * numLoadsPerSlide + num].loadNum : null}
                                        loadIndx={loadIndx}
                                        index={index}
                                        jumperOptions={this.state.jumperOptions}
                                        affStudentOptions={this.state.affStudentOptions}
                                        tandemStudentOptions={this.state.tandemStudentOptions}
                                        affInstructorOptions={this.state.staffOptions}
                                        tandemInstructorOptions={this.state.staffOptions}
                                        videographerOptions={this.state.staffOptions}
                                        coachOptions={this.state.staffOptions}
                                        loadsToShow={this.state.loadsToShow}
                                        iscompleted={iscompleted}
                                        loadsToShow={this.state.loadsToShow}
                                        fontSize={this.state.fontSize}
                                        columnsPerGroup={this.state.columnsPerGroup}
                                    />
                                );

                            })
                        }
                        {
                            !iscompleted && nextLoad != '' ? <Badge className='badgeHeader' color="info" >Next Load({nextLoad})</Badge> : ''
                        }
                    </div>
                </Slide>
            );
        }


        return activeSlides;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.settingObj !== nextProps.settingObj) {
            var numActiveSlides = 1;
            if (this.state.loads.length > 0) {
                numActiveSlides = Math.ceil(this.state.loads.length / nextProps.settingObj.loadsToShow);
            }

            var numCompletedSlides = Math.ceil(this.state.completedLoads.length / nextProps.settingObj.loadsToShow);
            if (this.state.completedLoads.length > 12 && localStorage.getItem("role") !== "video edit") {
                numCompletedSlides = Math.ceil(12 / nextProps.settingObj.loadsToShow);
            }
            var loads = loadsStore.getActiveLoadsForDisplay();
            this.setState({ ...nextProps.settingObj, loads, numActiveSlides, numCompletedSlides })
        }
    }
    render() {
        console.log("RENDERING LOAD MANAGER CENTER ****");
        var role = localStorage.getItem("role");
        let newCompletedLoads = []
        let newLoads = []
        this.state.completedLoads.forEach(val => {
            newCompletedLoads.push({
                ...val,
                isComplete: true
            })
        })

        this.state.loads.forEach(val => {

            newLoads.push({
                ...val,
                isComplete: false
            })
        })

        let newArrayMobileView = newCompletedLoads.concat(newLoads)

        const { loads, completedLoads, activeLoad, activeIndex, loadsToShow } = this.state;

        var screenWidth = window.innerWidth;

        const isMobile = screenWidth <= 500;

        var totalSlides;



        var currentSlide = 0;
        // var loadsLength= 0;
        var loadIndex = loads.map(x => x.loadNum).indexOf(loadsStore.activeloadNum);

        if (loadsStore.displayOnly) {
            if (screenWidth >= 1400) {
                currentSlide = Math.ceil(completedLoads.length / loadsToShow);
            }
            else if (screenWidth >= 992) {
                currentSlide = Math.ceil(completedLoads.length / 3)
            }
            else if (screenWidth >= 500) {
                currentSlide = Math.ceil(completedLoads.length / 2);
            }
        }
        else {
            if (screenWidth >= 1400) {
                if (loadIndex === -1) {
                    currentSlide = (Math.ceil(completedLoads.length / loadsToShow) + Math.ceil(loads.length / loadsToShow));
                    // console.log("🚀 ~ file: LoadManagerCenter.js ~ line 884 ~ render ~ currentSlide", currentSlide)

                }
                else {
                    loadIndex = loadIndex + 1;
                    currentSlide = (Math.ceil(completedLoads.length / loadsToShow) + Math.ceil(loadIndex / loadsToShow) - 1);
                }
            }
            else if (screenWidth >= 992) {
                if (loadIndex === -1) {
                    currentSlide = (Math.ceil(completedLoads.length / 3) + Math.ceil(loads.length / 3) - 1);
                }
                else {
                    loadIndex = loadIndex + 1;
                    currentSlide = (Math.ceil(completedLoads.length / 3) + Math.ceil(loadIndex / 3) - 1);
                }
            }
            else if (screenWidth >= 500) {
                if (loadIndex === -1) {
                    currentSlide = (Math.ceil(completedLoads.length / 2) + Math.ceil(loads.length / 2) - 1);
                }
                else {
                    loadIndex = loadIndex + 1;
                    currentSlide = (Math.ceil(completedLoads.length / 2) + Math.ceil(loadIndex / 2) - 1);
                }
            }
        }

        if (loads.length === 0 && completedLoads.length === 0) {
            return (
                <div>
                    <h1 style={{ color: 'white', marginTop: '0px', marginLeft: '10px' }}>
                        No Loads Active
                    </h1>
                    {this.state.isloading && <DonutLoader isLoading={this.state.isloading} addClass={'inloadmanager'} />}
                    <div className={"left-txt-btn"} >
                        {localStorage.getItem("role") !== "video edit" ?
                            <StaffCheckin /> : null
                        }
                    </div>
                    <div className={"right-txt-btn"} >
                        <p>
                            <Clock format="h:mm:ss A" interval={1000} ticking={true} />
                        </p>
                    </div>
                </div>
            );
        }
        var completedSlides = [];
        var nextLoadNum = 1;
        if (this.state.completedLoads.length > 0) {
            var loadNums = this.state.completedLoads.map(ld => ld.loadNum);
            maxLoadNum = Math.max(loadNums);
            nextLoadNum = maxLoadNum + 1;
        }
        if (this.state.completedLoads.length > 12 && role !== 'video edit') {
            completedSlides = this.renderSlides(this.state.completedLoads.slice(this.state.completedLoads.length - 12, this.state.completedLoads.length), this.state.numCompletedSlides, screenWidth, true, nextLoadNum);
        }
        else {
            completedSlides = this.renderSlides(this.state.completedLoads, this.state.numCompletedSlides, screenWidth, true, nextLoadNum)
        }
        nextLoadNum = 1;
        if (this.state.loads.length > 0) {
            var loadNums = this.state.loads.map(ld => ld.loadNum);
            var maxLoadNum = Math.max(loadNums);
            nextLoadNum = maxLoadNum + 1;
        }
        else if (this.state.completedLoads.length > 0) {
            var loadNums = this.state.completedLoads.map(ld => ld.loadNum);
            var maxLoadNum = Math.max(loadNums);
            nextLoadNum = maxLoadNum + 1;
        }
        totalSlides = this.state.numCompletedSlides + this.state.numActiveSlides;
        const activeSlides = this.renderSlides(this.state.loads, this.state.numActiveSlides, screenWidth, false, nextLoadNum)
        console.log('totalSlides: ' + totalSlides);
        // console.log("🚀 ~ file: LoadManagerCenter.js ~ line 945 ~ render ~ activeSlides, completedslides", activeSlides,completedSlides)

        // var slides = [];
        // var itemIndex = 1;
        // for (var index = 0; index < this.state.loads.length; index += 2) {
        //     if (index % 2 === 0) {
        //         slides.push(
        //             <CarouselItem
        //                 onExiting={this.onExiting}
        //                 onExited={this.onExited}
        //                 key={itemIndex}
        //             >
        //                 <div className="row" style={{ width: '100%', margin: 'auto' }} data-key={itemIndex}>
        //                     {this.state.loads[index] ? <Load load={this.state.loads[index]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                         tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length}
        //                         affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} /> : <Load load={{}} />}

        //                     {this.state.loads[index + 1] ? <Load load={this.state.loads[index + 1]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                         tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length + 1}
        //                         affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} /> : <Load load={{}} />}
        //                 </div>
        //             </CarouselItem>
        //         )
        //         itemIndex= itemIndex + 1;
        //     }
        // }

        // const slides = this.state.loads.map((item, index) => {
        //     return index % 2 == 0 && (
        //         <CarouselItem
        //             onExiting={this.onExiting}
        //             onExited={this.onExited}
        //             key={index}
        //         >
        //             <div className="row" style={{ width: '100%', margin: 'auto' }}>
        //                 {this.state.loads[index] ? <Load load={this.state.loads[index]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                     tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length}
        //                     affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} /> : <Load load={{}} />}

        //                 {this.state.loads[index + 1] ? <Load load={this.state.loads[index + 1]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                     tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length + 1}
        //                     affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} /> : <Load load={{}} />}
        //             </div>
        //         </CarouselItem>
        //     )
        // });

        // const slides = this.state.loads.map((item, index) => {
        //     return index % 2 == 0 ? (
        //         <div className="row" style={{ width: '100%', margin: 'auto' }}>

        //         <CarouselItem
        //             onExiting={this.onExiting}
        //             onExited={this.onExited}
        //             key={index}
        //         >
        //             {/* <img src={item.src} alt={item.altText} /> */}
        //             <Load load={this.state.loads[index]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                 tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length}
        //                 affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} />
        //             {/* <CarouselCaption captionText={item.caption} captionHeader={item.caption} /> */}
        //         </CarouselItem>

        //         <CarouselItem
        //             onExiting={this.onExiting}
        //             onExited={this.onExited}
        //             key={index + 1}
        //         >
        //             {this.state.loads[index + 1] && <Load load={this.state.loads[index + 1]} jumperOptions={this.state.jumperOptions} tandemInstructorOptions={this.state.staffOptions}
        //                 tandemStudentOptions={this.state.tandemStudentOptions} affInstructorOptions={this.state.staffOptions} index={index + completedLoads.length + 1}
        //                 affStudentOptions={this.state.affStudentOptions} videographerOptions={this.state.staffOptions} coachOptions={this.state.staffOptions} iscompleted={false} />}
        //         </CarouselItem>
        //             /</div>
        // });

        // const slides = items.map((item) => {
        //     return (
        //       <CarouselItem
        //         className="custom-tag"
        //         tag="div"
        //         key={item.id}
        //         onExiting={this.onExiting}
        //         onExited={this.onExited}
        //       >
        //         <CarouselCaption className="text-danger" captionText={item.caption} captionHeader={item.caption} />
        //       </CarouselItem>
        //     );
        //   });

        // //console.log("slides",slides)
        //console.log("currentSlide: ", currentSlide);
        //console.log('totalSlides: ', totalSlides);
        return (
            <div className="col-md-12 mainBlock">
                {/* 
                loads.length === 0 && !this.state.isloading &&
                 <div>
                     <h1 style={{ color: 'white', marginTop: '-50px', marginLeft: '10px' }}>No Loads Active</h1>
                 </div>
             } */}

                <DonutLoader isLoading={this.state.loading} addClass="sample1" />

                <div className="alert-panel">
                    {
                        this.state.iscompleted &&
                        <Alert color="success" className="alert-loadcomplete">
                            Load {this.state.completedLoadNum} Is Now Completed!
                        </Alert>
                    }
                    {
                        this.state.alert &&
                        <Alert color="warning" className="alert-loadcomplete">
                            {this.state.alertMessage}
                        </Alert>
                    }
                </div>

                {!isMobile ?
                    <div className="webShow">
                        {this.state.loads.length === 0 ? <h1 className="headingTopNoActive" style={{ color: 'white', marginTop: '0px' }}>No Loads Active</h1> : ''}
                        {/* <Carousel
                        activeIndex={activeIndex}
                        next={this.next}
                        previous={this.previous}
                        autoPlay={false}
                        >
                        {slides}
                        <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                        <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
                        </Carousel> */}
                        {console.log('before rendering carousel,' + loads.length + ", " + completedLoads.length)}

                        <CarouselProvider
                            key = {new Date()}
                            totalSlides={totalSlides}
                            currentSlide={completedSlides.length>0?completedSlides.length:0}
                            dragEnabled={false}
                            onClick={this.handleCarouselClick}
                        >
                            <ButtonBack className={loads.length === 0 && completedLoads.length !== 0 ? "carousel-back-btn btn noloadActive" : "carousel-back-btn btn"} style={loads.length !== 0 || completedLoads.length !== 0 ? { display: 'block', top: "88vh !important" } : { display: 'none' }}>
                                <img src={arrow} alt="arrowright" style={{ height: 24, margin: 'auto', display: 'block' }} />
                            </ButtonBack>
                            <Slider >
                                {completedSlides}
                                {activeSlides}

                                {/* {
                                this.renderSlides(this.state.completedLoads, totalCompletedSlides, screenWidth, true)
                            }
                            {
                                this.renderSlides(this.state.loads, totalActiveSlides, screenWidth, false)
                            } */}

                            </Slider>

                            <div>
                                <div className={"left-txt-btn"} >
                                    {localStorage.getItem("role") !== "video edit" ?
                                        <StaffCheckin /> : null
                                    }
                                </div>
                                <ButtonNext onClick={(val) => this.onNextClick(val)} className={loads.length === 0 && completedLoads.length !== 0 ? "carousel-next-btn btn noloadActive" : "carousel-next-btn btn"} style={loads.length !== 0 || completedLoads.length !== 0 ? { display: 'block', top: "88vh !important" } : { display: 'none' }}>
                                    <img src={arrow} alt="arrowright" style={{ height: 24, margin: 'auto', display: 'block', transform: 'rotate(180deg)' }} />
                                </ButtonNext>
                                <div className={"right-txt-btn"} >
                                    <p>
                                        <Clock format="h:mm:ss A" interval={1000} ticking={true} />
                                    </p>
                                </div>
                            </div>
                            <ButtonLast className="carousel-last-btn btn lightBlueButton hide">Last</ButtonLast>
                            <ButtonFirst className="carousel-first-btn btn lightBlueButton hide">First</ButtonFirst>

                        </CarouselProvider>
                    </div> : null
                }
                {isMobile ?
                    <div className="mobileShow">

                        {newCompletedLoads.length == 0 && newLoads.length == 0 ?
                            <h1 style={{ color: 'white', marginTop: '20px', fontSize: '20px', textAlign: 'center' }}>
                                No Loads Active
                            </h1> : ''
                        }

                        <CarouselProvider
                            currentSlide={newCompletedLoads.length}
                            totalSlides={newArrayMobileView.length}
                            dragEnabled={false}>
                            {
                                newCompletedLoads.length > 0 || newLoads.length > 0 ?
                                    <ButtonBack className="carousel-back-btn btn" style={{ top: "88vh !important" }}>
                                        <img src={arrow} alt="arrowright" style={{ height: 24, margin: 'auto', display: 'block' }} />
                                    </ButtonBack> : null}

                            {/* newCompletedLoads.concat(newLoads) */}

                            <Slider>
                                {newCompletedLoads.map((loads, index) => {
                                    return (
                                        <Slide index={index} style={{}} key={"slide" + index}>
                                            <div className="row" style={{ width: '100%', margin: 'auto' }}>
                                                {newCompletedLoads[index] ?
                                                    <Load usingWaitlist={this.state.usingWaitlist}
                                                        load={newCompletedLoads[index]}
                                                        loads={newCompletedLoads}
                                                        jumperOptions={this.state.jumperOptions}
                                                        tandemInstructorOptions={this.state.staffOptions}
                                                        tandemStudentOptions={this.state.tandemStudentOptions}
                                                        affInstructorOptions={this.state.staffOptions}
                                                        affStudentOptions={this.state.affStudentOptions}
                                                        videographerOptions={this.state.staffOptions}
                                                        coachOptions={this.state.staffOptions}
                                                        iscompleted={loads.isComplete ? true : false}
                                                        loadsToShow={this.state.loadsToShow}

                                                    />
                                                    : <Load load={{}} />}

                                            </div>
                                        </Slide>
                                    )
                                })
                                }
                                {newLoads.map((loads, index) => {
                                    return (
                                        <Slide index={index} style={{}} key={"slide" + index}>
                                            <div className="row" style={{ width: '100%', margin: 'auto' }}>
                                                {newLoads[index] ?
                                                    <Load usingWaitlist={this.state.usingWaitlist}
                                                        load={newLoads[index]}
                                                        loads={newLoads}
                                                        jumperOptions={this.state.jumperOptions}
                                                        tandemInstructorOptions={this.state.staffOptions}
                                                        tandemStudentOptions={this.state.tandemStudentOptions}
                                                        affInstructorOptions={this.state.staffOptions}
                                                        affStudentOptions={this.state.affStudentOptions}
                                                        videographerOptions={this.state.staffOptions}
                                                        coachOptions={this.state.staffOptions}
                                                        iscompleted={loads.isComplete ? true : false}
                                                        loadsToShow={this.state.loadsToShow}

                                                    />
                                                    : <Load load={{}} />}

                                            </div>
                                        </Slide>
                                    )
                                })
                                }
                            </Slider>
                            {
                                newCompletedLoads.length > 0 || newLoads.length > 0 ?
                                    <ButtonNext className="carousel-next-btn btn" style={{ top: "88vh !important" }}>
                                        <img src={arrow} alt="arrowright" style={{ height: 24, margin: 'auto', display: 'block', transform: 'rotate(180deg)' }} />
                                    </ButtonNext>
                                    : null
                            }
                            <ButtonLast className="carousel-last-btn btn lightBlueButton hide">
                                Last
                            </ButtonLast>
                        </CarouselProvider>
                    </div > : null
                }
            </div >
        )
    }
}

// export default LoadPage;
export default DragDropContext(HTML5Backend)(LoadPage);
